import { Distribute, IconButton, SvgEye, TextInput } from '@loomhq/lens';
import React, { useState } from 'react';

import styles from './styles.module.less';

export const MaskedInput = ({ ...props }) => {
  const [masked, setMasked] = useState(true);

  return (
    <Distribute className={styles.loomMaskedInputContainer}>
      <TextInput
        type={masked ? 'password' : 'text'}
        placeholder={masked ? '•••••••••••' : 'password'}
        {...props}
      />
      <IconButton
        altText={masked ? 'Reveal password' : 'Hide password'}
        icon={<SvgEye />}
        iconColor={masked ? 'grey4' : 'black'}
        onClick={() => setMasked(!masked)}
      />
    </Distribute>
  );
};
